import React from 'react';
import { useTranslation } from 'react-i18next';

import walkImg from '@/assets/explore-maatra/ongoing-care-walk.png';
import trendingImg from '@/assets/explore-maatra/ongoing-care-trending.png';
import medsImg from '@/assets/explore-maatra/ongoing-care-meds.png';
import { MAATRA_VIDEO_URL } from '@/utils/constants';

import ExploreScreen, { ExploreCard } from './ExploreScreen';

const BEIGE = 'radial-gradient(ellipse at center, rgba(236,221,184,1) 0%, rgba(245,235,225,1) 100%)';
const PINK = 'radial-gradient(ellipse at center, rgba(245,182,231,1) 0%, rgba(244,215,233,1) 100%)';
const PURPLE = 'radial-gradient(ellipse at center, rgba(209,193,237,1) 0%, rgba(242,225,245,1) 100%)';

const OngoingCare: React.FC = () => {
  const { t } = useTranslation();

  const cards: [ExploreCard, ExploreCard, ExploreCard] = [
    { img: walkImg, title: t('auth.ongoingCare.cards.walk'), thumbGradient: BEIGE, videoUrl: MAATRA_VIDEO_URL },
    { img: trendingImg, title: t('auth.ongoingCare.cards.trending'), thumbGradient: PINK, videoUrl: MAATRA_VIDEO_URL },
    { img: medsImg, title: t('auth.ongoingCare.cards.meds'), thumbGradient: PURPLE, videoUrl: MAATRA_VIDEO_URL },
  ];

  return (
    <ExploreScreen
      pill={t('auth.ongoingCare.pill')}
      bodyText={t('auth.ongoingCare.bodyText')}
      cards={cards}
    />
  );
};

export default OngoingCare;
